<template>
  <!-- 头部整体盒子 -->
  <div id="headeren" :class="['container-fuild', isNavFixed ? 'is-nav-fixed' : '', isNavDown ? 'is-nav-down' : '']">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs hidden-sm">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img @click="GoTop()" src="@/assets/img/logo_black.png" />
      </div>
      <!-- 导航内容 -->
      <div class="header-nav-right">
        <ul class="header-nav-wrapper">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" @mouseover="showDropDown(index)" @mouseout="hideDropDown">
            <template v-if="item.children.length > 0">
              <template v-if="item.name === 'baseニュース'">
                <router-link :to="item.path" class="name">
                  <span>base</span>ニュース
                </router-link>
              </template>
              <template v-else-if="item.name === 'baseについて'">
                <router-link :to="item.path" class="name">
                  <span>base</span>について
                </router-link>
              </template>
              <template v-else-if="item.name === 'ESG対策と実践'">
                <router-link :to="item.path" class="name">
                  <span>ESG</span>対策と実践
                </router-link>
              </template>
              <template v-else>
                <router-link :to="item.path" class="name">
                  {{ item.name }}
                </router-link>
              </template>
              <span class="nav-icon el-icon-caret-bottom" :class="item.sub ? 'nav-icon-active' : ''"></span>
            </template>
            <template v-else>
              <router-link :to="item.path">
                {{ item.name }}
              </router-link>
            </template>
            <dl v-show="item.sub" class="animated fadeIn">
              <dt v-for="(i, n) in item.children" :key="n">
                <template v-if="i.name === 'ESG実践'">
                  <router-link :to="i.path" :class="i.css"><span>ESG</span>実践</router-link>
                </template>
                <template v-else>
                  <router-link :to="i.path" :class="i.css">{{ i.name }}</router-link>
                </template>
              </dt>
            </dl>
          </li>
        </ul>
        <div class="changelan">
          <span @click="changeLanguage(1)">CN</span> | <span @click="changeLanguage(2)">EN</span> | <span
            class="lannow">JP</span>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-sm visible-xs">
      <div class="header-nav-m-ct">
        <div class="header-nav-m-logo">
          <img class="center-block" src="@/assets/img/logo_black.png" alt="logo" @click="GoTop()" />
        </div>
        <div class="header-nav-m-icon" @click="nMenuClick">
          <img src="@/assets/img/header_menu_black.png" alt="" />
        </div>
      </div>
    </div>
    <div class="menu-expanded-bg visible-sm visible-xs" v-if="nMenvRight !== '-100%'" @click="nMenuClick"></div>
    <div class="menu-expanded visible-sm visible-xs" :style="{ right: nMenvRight }">
      <div class="m-ex-top">
        <!-- <div class="m-ex-logo">
          <img src="@/assets/img/logo_black.png" class="logo" />
        </div> -->
        <div class="m-ex-close" @click="nMenuClick">
          <img src="@/assets/img/header_menu_close.png" alt="" />
        </div>
      </div>
      <ul class="m-ex-el-nav">
        <section v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)" class="m-ex-item-container">
          <li class="m-ex-menu-item" :class="item.sub ? 'm-ex-menu-item-active' : ''">
            <template v-if="item.children.length > 0">
              <template v-if="item.name === 'baseニュース'">
                <a class="name" @click="showDropDown(index)"><span>base</span>ニュース</a>
              </template>
              <template v-else-if="item.name === 'baseについて'">
                <a class="name" @click="showDropDown(index)"><span>base</span>について</a>
              </template>
              <template v-else-if="item.name === 'ESG対策と実践'">
                <a class="name" @click="showDropDown(index)"><span>ESG</span>対策と実践</a>
              </template>
              <template v-else>
                <a class="name" @click="showDropDown(index)">{{ item.name }}</a>
              </template>
              <span class="nav-icon el-icon-caret-bottom" :class="item.sub ? 'nav-icon-active' : ''"></span>
            </template>
            <template v-else>
              <router-link :to="item.path">
                {{ item.name }}
              </router-link>
            </template>
            <dl v-show="item.sub" class="animated fadeIn">
              <template v-if="item.name === 'アパートメントについて' || item.name === 'baseニュース' || item.name === 'ESG対策と実践'">
                <dt>
                  <router-link :to="item.path">All</router-link>
                </dt>
              </template>
              <template v-if="item.name === 'baseについて'">
                <dt>
                  <router-link :to="item.path"><span>base</span>について</router-link>
                </dt>
              </template>
              <dt v-for="(i, n) in item.children" :key="n">
                <template v-if="i.name === 'ESG実践'">
                  <router-link :to="i.path" :class="i.css"><span>ESG</span>実践</router-link>
                </template>
                <template v-else>
                  <router-link :to="i.path" :class="i.css">{{ i.name }}</router-link>
                </template>
              </dt>
            </dl>
          </li>
        </section>
      </ul>
      <div class="changelan">
        <span @click="changeLanguage(1)">CN</span> | <span @click="changeLanguage(2)">EN</span>| <span
          class="lannow">JP</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Headerjp",
  data() {
    return {
      i: 0,
      isNavFixed: false,
      isNavDown: false,
      nMenvRight: "-100%",
      // navIndex: sessionStorage.getItem("navIndex")
      //   ? sessionStorage.getItem("navIndex")
      //   : 0,
      //navIndex: 0,
      menuName: "Home",
      menuClass: "el-icon-caret-bottom",
      navList: [
        {
          name: "ホーム",
          path: "/jp",
          children: [],
        },
        {
          name: "アパートメントについて",
          path: "/jp/apartment",
          sub: false,
          children: [{
            name: 'basePLUS',
            path: '/jp/apartment?type=1',
            css: 'cssen'
          }, {
            name: 'base',
            path: '/jp/apartment?type=2',
            css: 'cssen'
          }, {
            name: 'baseLITE',
            path: '/jp/apartment?type=3',
            css: 'cssen'
          }],
        },
        {
          name: "安全対策",
          path: "/jp/checkin",
          children: [],
        },
        {
          name: "ニュース",
          path: "/jp/trend",
          sub: false,
          children: [
            {
              name: 'ハイライト',
              path: '/jp/trend?type=1',
              css: ''
            }, {
              name: 'イベント',
              path: '/jp/trend?type=2',
              css: ''
            }, {
              name: 'イベント予告',
              path: '/jp/trend?type=3',
              css: ''
            }
          ],
        },
        {
          name: "お知らせ",
          path: "/jp/aboutus",
          sub: false,
          children: [{
            name: '採用情報',
            path: '/jp/jobchance',
            css: ''
          },
          {
            name: 'お問い合わせ',
            path: '/jp/contactus',
            css: ''
          }],
        },
        {
          name: "パートナー募集",
          path: "/jp/business",
          children: [],
        },
        {
          name: "ESG",
          path: "/jp/esg",
          sub: false,
          children: [
            {
              name: '環境',
              path: '/jp/esg?type=1',
              css: ''
            }, {
              name: '社会',
              path: '/jp/esg?type=2',
              css: ''
            }, {
              name: 'ガバナンス',
              path: '/jp/esg?type=3',
              css: ''
            }, {
              name: 'ESG実践',
              path: '/jp/esg?type=4',
              css: ''
            }
          ],
        },
      ],
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },

  watch: {
    $route: {
      handler(to, from) {
        if (to != from) {
          this.nMenvRight = "-100%";
        }
        this.navList.map(item => item.sub = false);
      },
      immediate: true
    }
  },

  computed: {
    navIndex() {
      //console.log(this.$route.path)
      let that = this,
        _idx;
      if (that.$route.path === '/jp/apartment/apadetail') {
        _idx = 1;
      } else if (that.$route.path === '/jp/jobchance' ) {//|| that.$route.path === '/jp/business'
        _idx = 4;
      } else {
        _idx = that.navList.findIndex((item) => (item.path === that.$route.path));
      }
      return _idx
    }
  },

  methods: {
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        document.body.scrollTop
      var scroll = scrollTop - this.i;
      this.i = scrollTop;
      if (scroll < 0) {
        this.isNavFixed = true;
        this.isNavDown = false;
      } else {
        this.isNavFixed = false;
        this.isNavDown = true;
      }
      if (this.i == 0) {
        this.isNavFixed = false;
        this.isNavDown = false;
      }
      //this.navList.map(item => item.sub = false)
    },

    navClick(index, name) {
      //this.navIndex = index;
      //sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },

    showDropDown(e) {
      this.navList.forEach((item, index) => {
        if (e === index) {
          if (item.sub) {
            item.sub = false;
          } else {
            item.sub = true;
          }
        } else {
          item.sub = false;
        }
      })
    },

    hideDropDown(e) {
      this.navList.map(item => item.sub = false)
    },

    menuClick() {
      if (this.menuClass == "el-icon-caret-bottom") {
        this.menuClass = "el-icon-caret-top";
      } else {
        this.menuClass = "el-icon-caret-bottom";
      }
    },
    nMenuClick() {
      if (this.nMenvRight == "-100%") {
        this.nMenvRight = "0";
      } else {
        this.nMenvRight = "-100%";
      }
    },

    changeLanguage(e) {
      //console.log(this.$route.fullPath)
      let _path = this.$route.fullPath,
        _str = _path.match(/jp(\S*)/)[1];
      //console.log(_str)
      if (e === 1) {
        let _link = _str === '' ? '/' : _str
        this.$router.push({ path: `${_link}` });
      } else {
        this.$router.push({ path: `/en${_str}` });
      }
    },

    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  },
};
</script>
<style lang="scss" scoped>
a {
  &:focus {
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
  }
}

/* 顶部 */
#headeren {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 1s;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  font-family: $KM;

  &.is-nav-fixed {
    position: fixed;
    z-index: 1001;
    background: #fff;
    box-shadow: 0 1px 10px 0 rgb(90 43 129 / 20%);
  }

  &.is-nav-down {
    top: -100%;
  }

  .header-nav {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::before {
      display: none;
    }

    &::after {
      display: none;
    }

    .header-nav-logo {
      display: flex;
      cursor: pointer;

      img {
        max-width: 80px;
      }
    }

    .header-nav-right {
      display: flex;
      align-items: center;

      .header-nav-wrapper {
        margin: 0;
        display: flex;
        font-size: 14px;
        color: #272727;

        li {
          margin-left: 35px;
          position: relative;

          .name {
            cursor: pointer;

            &:hover {
              color: #3C5896;
            }
          }

          .nav-icon {
            transition: all .3s;

            &.nav-icon-active {
              &.el-icon-caret-bottom {
                transform: rotate(180deg);
              }
            }
          }


          >a {
            color: #272727;

            span {
              font-family: $FM6
            }

            &:hover {
              color: #3C5896;
              text-decoration: none;
            }
          }

          dl {
            width: 200px;
            position: absolute;
            left: 50%;
            top: 90%;
            margin-left: -100px;
            padding-top: 10px;
            animation-duration: .5s;

            dt {
              width: 200px;
              height: 36px;
              background: rgba(255, 255, 255, 0.8);
              text-align: center;
              line-height: 36px;
              border-bottom: 1px solid #fff;

              &:last-child {
                border-bottom: none;
              }

              a {
                font-size: 12px;
                font-weight: normal;
                color: #272727;
                text-transform: uppercase;

                span {
                  font-family: $FM6
                }

                &:hover {
                  color: #3C5896;
                }

                &.cssen {
                  font-family: $FM6;
                  text-transform: inherit;
                }
              }
            }
          }

          &.active {
            >a {
              color: #3C5896;
              font-weight: 700;
              border-bottom: 1px solid #3C5896;

              &:hover {
                text-decoration: none;
              }
            }
          }
        }
      }

      .changelan {
        margin-left: 50px;
        font-family: $FM6;

        span {
          font-size: 14px;
          font-weight: normal;
          color: #272727;
          cursor: pointer;

          &.lannow {
            text-decoration: underline;
            color: #3c5896;
            font-weight: 700;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 997px) {
  #headeren {
    background: none;
    height: 55px;
    position: fixed;

    &.is-nav-down {
      top: 0 !important;
    }

    &.is-nav-fixed {}
  }

  .header-nav-m {
    background: #fff;
    height: 55px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transition: all 0.5s;
    box-shadow: 0 1px 10px 0 rgb(90 43 129 / 20%);

    .header-nav-m-ct {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header-nav-m-logo {
        margin-left: 15px;

        img {
          max-width: 55px;
        }
      }

      .header-nav-m-icon {
        width: 26px;
        margin-right: 15px;

        img {
          width: 26px;
        }
      }
    }
  }

  .menu-expanded-bg {
    height: 100vh;
    width: 100%;
    z-index: 1640;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  .menu-expanded {
    overflow-y: auto;
    display: block;
    height: 100vh;
    width: 61%;
    padding: 24px 18px;
    position: fixed;
    top: 0;
    z-index: 1650;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    box-shadow: 0 2px 6px 2px hsl(194deg 8% 50% / 22%);

    .m-ex-top {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 36px;

      .m-ex-logo {
        img {
          max-width: 85px;
        }
      }

      .m-ex-close {
        img {
          max-width: 20px;
        }
      }
    }

    .m-ex-el-nav {
      list-style: none;
      position: relative;
      margin: 0;
      padding-left: 0;

      .m-ex-menu-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding: 20px 0;
        letter-spacing: 0.4px;
        transition: all .5s;
        height: auto;

        .nav-icon {
          transition: all .3s;

          &.nav-icon-active {
            &.el-icon-caret-bottom {
              transform: rotate(180deg);
            }
          }
        }

        >a {}

        a {
          font-size: 14px;
          line-height: 18px;
          color: #272727;

          span {
            font-family: $FM6;
          }
        }

        dl {
          margin-top: 10px;
          margin-bottom: 0;
          font-size: 12px;

          dt {
            padding: 5px 0;

            a {
              font-size: 12px;

              &.cssen {
                font-family: $FM6;
                text-transform: inherit;
              }
            }

          }
        }
      }
    }

    .changelan {
      font-family: $FM6;
      padding-top: 20px;

      span {
        font-size: 14px;
        font-weight: normal;
        color: #272727;
        cursor: pointer;

        &.lannow {
          text-decoration: underline;
          color: #3c5896;
          font-weight: 700;
        }
      }
    }
  }
}

@media screen and (min-width: 998px) {
  #headeren {
    .header-nav {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}


@media screen and (min-width: 1200px) {
  #headeren {
    .header-nav {
      width: 1200px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}

@media screen and (min-width: 1679px) {}
</style>



// WEBPACK FOOTER //
// src/components/Headerjp.vue